import { RadioGroup } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';
import { DepreciationQuestion } from './DepreciationQuestion.tsx';

type Props = {
  question: string;
  trueLabel: string;
  falseLabel: string;
  field: string;
  forceHorizontal?: boolean;
  trueFirst?: boolean;
};

export function DepreciationToggle({
  question,
  trueLabel,
  falseLabel,
  field,
  forceHorizontal,
  trueFirst,
}: Props) {
  const { control } = useZodFormContext();
  const items = trueFirst
    ? [
        { label: trueLabel, value: 'true' },
        { label: falseLabel, value: 'false' },
      ]
    : [
        { label: falseLabel, value: 'false' },
        { label: trueLabel, value: 'true' },
      ];

  return (
    <DepreciationQuestion question={question}>
      <Controller
        name={field}
        control={control}
        render={({ field }) => {
          return (
            <RadioGroup
              size="sm"
              forceHorizontal={forceHorizontal}
              items={items}
              columnGap={forceHorizontal ? '1.5rem' : undefined}
              gap={forceHorizontal ? undefined : '.5rem'}
              {...field}
            />
          );
        }}
      />
    </DepreciationQuestion>
  );
}
